import React, { useRef, useEffect } from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { noop } from '../../utils/functions.js';
import dayjs from '../../utils/dayjs.js';
import { StyledTd } from './styledComponents.js';
import useLang from '../../hooks/useLang.js';
import useTheme from '../../hooks/useTheme.js';

var TODAY = dayjs();

var Td = function Td(_ref) {
  var day = _ref.day,
      selectedDate = _ref.selectedDate,
      isFocusedDay = _ref.isFocusedDay,
      isMonthToggle = _ref.isMonthToggle,
      selectDate = _ref.selectDate,
      isHidden = _ref.isHidden,
      setFocusedDayRef = _ref.setFocusedDayRef,
      arrowKeyHandler = _ref.arrowKeyHandler,
      tabKeyHandler = _ref.tabKeyHandler,
      hasFocus = _ref.hasFocus;
  var lang = useLang();
  var theme = useTheme();
  var year = day.year,
      month = day.month,
      date = day.date,
      isDisabled = day.isDisabled;
  var ref = useRef(null);
  var thisDay = dayjs([year, month, date]).locale(lang); // focus on the currently selected date

  useEffect(function () {
    if (isFocusedDay) {
      setFocusedDayRef(ref);

      if (!isMonthToggle) {
        ref.current.focus();
      }
    }
  }, [isFocusedDay, isMonthToggle, setFocusedDayRef]);

  var keypressHandler = function keypressHandler(event) {
    arrowKeyHandler(event);
    tabKeyHandler(event);
  };

  var isSelected = selectedDate && year === selectedDate.year && month === selectedDate.month && selectedDate.date === date;
  var isCurrentDate = year === TODAY.year() && month === TODAY.month() && date === TODAY.date();
  var tabIndex = isSelected && !isDisabled ? 0 : -1;
  return isHidden ? /*#__PURE__*/React.createElement("td", null) : /*#__PURE__*/React.createElement(StyledTd, {
    "aria-selected": isSelected,
    tabIndex: tabIndex,
    selected: isSelected,
    id: "cell-".concat(year, "-").concat(month, "-").concat(date),
    onClick: function onClick(event) {
      return isDisabled ? noop : selectDate(event, year, month, date);
    },
    isCurrentDate: isCurrentDate,
    isFocused: hasFocus && isFocusedDay,
    ref: ref,
    disabled: isDisabled,
    "aria-label": thisDay.format('LL'),
    role: "gridcell",
    theme: theme,
    onKeyDown: keypressHandler
  }, date);
};

process.env.NODE_ENV !== "production" ? Td.propTypes = {
  day: PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    date: PropTypes.number,
    isDisabled: PropTypes.bool
  }),
  isFocusedDay: PropTypes.bool,
  isMonthToggle: PropTypes.bool,
  isHidden: PropTypes.bool,
  selectDate: PropTypes.func.isRequired,
  selectedDate: PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    date: PropTypes.number
  }),
  setFocusedDayRef: PropTypes.func.isRequired,
  arrowKeyHandler: PropTypes.func.isRequired,
  tabKeyHandler: PropTypes.func.isRequired,
  hasFocus: PropTypes.bool
} : void 0;
Td.defaultProps = {
  day: {},
  isFocusedDay: false,
  isMonthToggle: false,
  isHidden: false,
  selectedDate: {},
  hasFocus: false
};
var Td$1 = Td;

export { Td$1 as default };
